var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-checkbox',_vm._b({attrs:{"value":_vm.value},on:{"input":_vm.updateValue,"change":_vm.onChange}},'q-checkbox',_vm.$attrs,false),[(_vm.infoText || _vm.infoTitle)?_c('info-icon',{staticClass:"all-pointer-events q-ml-xs",attrs:{"title":_vm.infoTitle,"text":_vm.infoText,"color":_vm.infoIconColor,"size":"1em"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }